module.exports = __webpack_public_path__ + "img/bookshelf19.ee41be63.jpg";